import {connect} from "react-redux";
import { setDialogTweetShow } from "../../redux/actions/actions.js";

const Nav_BtnTweet = (props) => {
    const handleClick = () => {
        props.onSetDialogTweetShow("show");
    }

    return(
        <button onClick={handleClick} className={`nav_btn_tweet customizecolorchange_hover customizecolorchange_${props.color_button}`}>Tweet</button>
    )
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSetDialogTweetShow: (text) => dispatch(setDialogTweetShow(text))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Nav_BtnTweet);